module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(_.size(compare)){ 
__p+='\n	<div class="history-chart">\n		<div class="history-chart-controls">\n			<div class="select-box">\n				<select name="by_year" id="by_year">\n					';
 _.each(years_range, function(year){ 
__p+='\n						<option value="'+
((__t=( year ))==null?'':_.escape(__t))+
'" '+
((__t=( _.eq(selected_year, year) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n							'+
((__t=( year ))==null?'':_.escape(__t))+
'\n						</option>\n					';
 }) 
__p+='\n				</select>\n			</div>\n			<div class="select-box">\n				<select name="by_stats" id="by_stats">\n					';
 _.each(history_stats_options, function(stat){ 
__p+='\n						<option value="'+
((__t=( stat.key ))==null?'':_.escape(__t))+
'" '+
((__t=( _.eq(selected_history_stat, stat.key) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n							'+
((__t=( stat.value ))==null?'':_.escape(__t))+
'\n						</option>\n					';
 }) 
__p+='\n				</select>\n			</div>\n		</div>\n		<div class="history-chart-container">\n			<canvas id="history-chart"></canvas>\n		</div>\n	</div>\n';
 } 
__p+='';
}
return __p;
};
